import { loadLib } from "./loadLib"

/**
 * 
 * @param {Array} libs Array de objetos con las librerías a cargar
 */
export async function loadAllLibs(libs) {

    try {
        const promises = libs.map(lib => loadLib(lib))
        await Promise.all(promises);
    } catch (error) {
        console.error(error)
    }

}

